import { connectorRegistryApi, type BackendConnectorRegistryEntry } from "../api";
import { mapBackendConnectorRegistry } from "./connectorRegistry.mapper";

export const connectorRegistryService = {
  list: async () => {
    const entries: BackendConnectorRegistryEntry[] = await connectorRegistryApi.list();
    return mapBackendConnectorRegistry(entries);
  },
};
